const shippingMethodEnum = Object.freeze({
    PRODUCT_WISE: 5,
    FLAT_RATE_WISE: 10,
    AREA_WISE: 15,
    SKYDROPX: 20,
    HYBRID: 25,
});
export default shippingMethodEnum;
